// Color de identidad del módulo Caja Instalación — mismo patrón que
// cajaChica/theme.js (CAJA_CHICA_COLOR), un tono distinto para diferenciarlo a simple
// vista del resto de las Cajas.
export const CAJA_INSTALACION_COLOR = "#e65100";
